import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MomentModule } from 'ngx-moment';

import { HeadingComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'text-presenter',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="text-presenter">
      <rt-heading varaint="heading small" margin-bottom-small-xx>
        {{ config().heading }}
      </rt-heading>
      @let kind = config().kind;
      @let value = config().value;
      @if (kind.type === 'text') {
        <p text-darkest [style.white-space]="kind.multiline ? 'pre-wrap' : 'normal'">
          {{ value ?? EMPTY_VALUE }}
        </p>
      } @else if (kind.type === 'date') {
        <p text-darkest>
          {{ value ? (value | amDateFormat: kind.format) : EMPTY_VALUE }}
        </p>
      } @else if (kind.type === 'link') {
        @if (value) {
          <p text-darkest>
            <a [href]="value" target="_blank" rel="noopener noreferrer">
              {{ value ?? '-' }}
            </a>
          </p>
        } @else {
          <p text-darkest>{{ EMPTY_VALUE }}</p>
        }
      }
    </div>
  `,
  imports: [HeadingComponent, MomentModule],
})
export class TextPresenterComponent {
  protected readonly EMPTY_VALUE = '-';

  public config = input.required<{
    heading: string;
    value: string | null;
    kind:
      | {
          type: 'text';
          multiline: boolean;
        }
      | {
          type: 'date';
          format: string;
        }
      | {
          type: 'link';
        };
  }>();
}
